module.exports = __webpack_public_path__ + "assets/images/logo.045d4b99.svg";